import { InjectionToken } from '@angular/core';

export const API_ROOT_TOKEN: InjectionToken<string> = new InjectionToken<string>('apiRoot');
